import {
  trackFirstSession,
  trackPageVisit,
  trackSessionEnd,
  trackSessionStart,
} from '~/services/exponeaEvents.service';

export default defineNuxtPlugin(async (nuxtApp) => {
  if (!import.meta.client) return;

  trackFirstSession();
  trackSessionStart();

  const router = nuxtApp.$router as any;

  //  Ensure router is fully ready before tracking first page
  await router.isReady();

  //  Track first page only once here
  trackPageVisit(router.currentRoute.value.fullPath);

  //  Track all future navigations (won't duplicate first one)
  router.afterEach((to: any, from: any) => {
    if (to.fullPath !== from.fullPath) {
      trackPageVisit(to.fullPath);
    }
  });

  window.addEventListener('beforeunload', () => {
    trackSessionEnd();
  });
});
